// Now unused - for reference only

import {SaasIdentifier} from 'src/types/Saas';

// OAuth
export const saasRequiresNoUserInput = (saasIdentifier: string) => {
  return (
    saasIdentifier === SaasIdentifier.docusign ||
    saasIdentifier === SaasIdentifier.microsoft365 ||
    saasIdentifier === SaasIdentifier.googlews ||
    saasIdentifier === SaasIdentifier.atlassian ||
    saasIdentifier === SaasIdentifier.dropbox ||
    saasIdentifier === SaasIdentifier.employmenthero ||
    saasIdentifier === SaasIdentifier.lucidchart ||
    saasIdentifier === SaasIdentifier.manageengine ||
    saasIdentifier === SaasIdentifier.xero ||
    saasIdentifier === SaasIdentifier.smartsheet ||
    saasIdentifier === SaasIdentifier.slack ||
    saasIdentifier === SaasIdentifier.zoom
  );
};

export const isOAuthWithExtrasSaas = (saasIdentifier: string) => {
  return (
    saasIdentifier === SaasIdentifier.zendesk ||
    saasIdentifier === SaasIdentifier.github ||
    saasIdentifier === SaasIdentifier.salesforce ||
    saasIdentifier === SaasIdentifier.egnyte
  );
};

export const saasCanFinishConnectionSetup = (saasIdentifier: string) => {
  return (
    saasIdentifier === SaasIdentifier.googlews ||
    saasIdentifier === SaasIdentifier.atlassian
  );
};

